<div class="col-xl-12">
    <app-cdk-select [menuDefinitivo]="menuDefinitivo" (buttonClick)="handleButtonClick($event)"></app-cdk-select>
    <label>Condicion:</label> 
    <div class="row">
        <div class="col-9">
            <input type="text" [(ngModel)]="condicion" (ngModelChange)="onCondicionEditada()" id="condicion" [mentionConfig]="mentionConfig" [disabled]="loading"
                   [ngClass]="{'border-red': isInValid, 'border-green': !isInValid}">
        </div>
        <div class="col-3" style="display:flex; align-items:center; gap:4px; flex-wrap:nowrap;">
            <button class="icon-button" (click)="interpretarCondicion()" title="Asistente IA">
                <mat-icon>smart_toy</mat-icon>
            </button>
            <button [disabled]="guardando || !condicion" (click)="guardarCondicion()" class="icon-button" title="Guardar condición">
                <mat-icon>{{guardando ? 'hourglass_empty' : 'save'}}</mat-icon>
            </button>
        </div>
    </div>
    <div class="row" *ngIf="isInValid || messageInvalid">
        <div class="col-12">
            <span class="text-danger small-text" *ngIf="isInValid">{{this.messageInvalid}}</span>
            <span class="text-muted small-text" *ngIf="!isInValid && messageInvalid">{{this.messageInvalid}}</span>
        </div>
    </div>

    <div *ngIf="this.tabIndex != 2" class="col-12" style="padding-bottom: 0.5rem; padding-top: 0.5rem;">
        <div class="col-xl-12 d-flex gap-1">            
            <div [ngClass]="isModelsRoute ? 'col-3' : 'col-4'">
              <button class="cond-btn" title="{{ isModelsRoute ? 'Agregar condición de Entrada' : 'Agregar condición de Mercado' }}"
                [disabled]="!!planificadorsv.loadingModel || planificadorsv.noCondiciones || isInValid || condicion.length == 0"
                (click)="addCondition('Entrada')">
                <mat-icon>input</mat-icon>
                <span>{{ isModelsRoute ? 'Entrada' : 'Mercado' }}</span>
              </button>
            </div>
            <div [ngClass]="isModelsRoute ? 'col-3' : 'col-4'">
              <button class="cond-btn" title="Agregar condición de Índice"
                [disabled]="!planificadorsv.showIndice || !!planificadorsv.loadingModel || planificadorsv.noCondiciones || isInValid || condicion.length == 0"
                (click)="addCondition('Indice')">
                <mat-icon>bar_chart</mat-icon>
                <span>Indice</span>
              </button>
            </div>
            <div [ngClass]="isModelsRoute ? 'col-3' : 'col-4'">
              <button class="cond-btn" title="Agregar condición de Volatilidad"
                [disabled]="!planificadorsv.showVolatilidad || !!planificadorsv.loadingModel || planificadorsv.noCondiciones || isInValid || condicion.length == 0"
                (click)="addCondition('Volatilidad')">
                <mat-icon>equalizer</mat-icon>
                <span>Volatilidad</span>
              </button>
            </div>
            <div class="col-3" *ngIf="isModelsRoute">
              <button class="cond-btn" title="Agregar condición de Salida"
                [disabled]="!!planificadorsv.loadingModel || planificadorsv.noCondiciones || isInValid || condicion.length == 0"
                (click)="addCondition('Salida')">
                <mat-icon>output</mat-icon>
                <span>Salida</span>
              </button>
            </div>
        </div>       
    </div>
</div>